import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as ReportsActions from './reports-store.actions';
import { Observable, map } from 'rxjs';
import * as ReportsSelectors from './reports-store.selectors';
import { DailyReports, SummaryReports } from '../models/reports.models';
import { IDailyReportState } from './reports-store.state';
import { TableData } from '@shared/ui/tables';

@Injectable({
  providedIn: 'root',
})
export class ReportsFacade {
  public constructor(private readonly store: Store<IDailyReportState>) {}

  public listPaginationDailyReports(query: string): void {
    this.store.dispatch(ReportsActions.listPaginationDailyReports({ query: query }));
  }

  public getPaginationDailyReports(): Observable<TableData<DailyReports>> {
    return this.store.select(ReportsSelectors.reportsState).pipe(map((x) => new TableData(x.filteredDailyReportsTotalCount, x.paginatedDailyReports)));
  }

  public listPaginationSummaryReports(query: string): void {
    this.store.dispatch(ReportsActions.listPaginationSummaryReports({ query: query }));
  }

  public getPaginationSummaryReports(): Observable<TableData<SummaryReports>> {
    return this.store.select(ReportsSelectors.reportsState).pipe(map((x) => new TableData(x.filteredSummaryReportsTotalCount, x.paginatedSummaryReports)));
  }

  public isLoadingReport(): Observable<boolean> {
    return this.store.select(ReportsSelectors.isLoadingReport);
  }
}
